import React, { useEffect, useState } from 'react';
import axios from 'axios';
import facebook from './Images/facebook.png';
import insta from './Images/insta.png';
import linkdin from './Images/linkdin.svg';

interface MemberItem {
  id: number;
  name: string;
  email: string;
  company_name?: string;
  designation?: string;
  profile?: string;
  role?: string;
  about_company?: string;
  point?: number;
  delete?: number;
  status?: string;
  expire?: string;
}

const Teams = () => {
  const [activeMembers, setActiveMembers] = useState<MemberItem[]>([]);

  useEffect(() => {
    const fetchActiveMembers = async () => {
      try {
        const response = await axios.get('https://rmbbackend.rmbjaipur.com/auth/allusersinfo');
        const list: MemberItem[] = Array.isArray(response.data) ? response.data : [];
        // Show only active members in recent society year
        const currentYearStart = new Date('2024-01-01');
        const filtered = list.filter((m) => {
          const isNotDeleted = m.delete !== 1;
          const isNotAdmin = m.role !== 'super-admin';
          const isActiveStatus = m.status ? m.status.toLowerCase() === 'active' : true;
          const isRecentSocietyYear = !m.expire || new Date(m.expire) >= currentYearStart;
          return isNotDeleted && isNotAdmin && isActiveStatus && isRecentSocietyYear;
        });
        setActiveMembers(filtered);
      } catch (error) {
        console.error('Error fetching active team members:', error);
      }
    };

    fetchActiveMembers();
  }, []);

  return (
    <div>
      <div className="bg-[#1E2A3A] py-14 px-[8%] border-t border-slate-700">
        <div className="flex flex-wrap w-[100%] justify-between items-center mb-10">
          <div className="sm:w-[60%]">
            <p className="text-xs text-[#FDBC12] font-extrabold uppercase tracking-wider mb-1">
              Active Members (Recent Society Year)
            </p>
            <h2 className="text-[36px] font-extrabold text-[#F1F4F9]">
              Team RMB <span className="text-[#FDBC12]">Jaipur</span>
            </h2>
          </div>
          <div className="sm:w-[40%] flex justify-end">
            <button
              className="bg-[#02256D] hover:bg-[#03369B] px-6 py-3 rounded-lg text-[#F1F4F9] text-sm font-bold shadow-md transition"
              onClick={() => {
                window.location.href = '/members';
              }}
            >
              View All Members ({activeMembers.length})
            </button>
          </div>
        </div>

        {/* Dynamic Member Cards Grid */}
        <div className="w-[100%] flex flex-wrap justify-between gap-y-8">
          {activeMembers.length === 0 ? (
            <div className="text-slate-400 font-semibold py-8 text-center w-full">
              No active society members found.
            </div>
          ) : (
            activeMembers.slice(0, 4).map((data) => (
              <div key={data.id} className="flex flex-wrap lg:w-[48%] w-[100%] gap-4 bg-[#101729] p-6 rounded-xl border border-slate-700/70 hover:border-[#FDBC12] transition shadow-lg">
                <div className="w-[140px] h-[140px] p-1 border-2 border-[#FDBC12] rounded-full overflow-hidden flex-shrink-0 mx-auto sm:mx-0 shadow-md">
                  <img
                    className="w-full h-full rounded-full object-cover"
                    src={data.profile ? (data.profile.startsWith('http') ? data.profile : `https://rmbbackend.rmbjaipur.com/${data.profile.replace(/\\/g, '/')}`) : 'https://via.placeholder.com/140?text=Member'}
                    alt={data.name}
                    onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/140?text=Member'; }}
                  />
                </div>
                <div className="sm:w-[60%] w-[100%] flex flex-col justify-between sm:mt-0 mt-2">
                  <div>
                    <div className="flex justify-between items-start">
                      <h5 className="sm:text-[20px] text-[17px] font-bold text-[#F5F5F5]">{data.name}</h5>
                      <span className="bg-[#FDBC12] text-[#0A2451] text-xs font-black px-2.5 py-0.5 rounded-full shadow">
                        🏆 {data.point || 0} Pts
                      </span>
                    </div>
                    <p className="text-[13px] font-medium text-[#FDBC12] mt-0.5">{data.designation || 'RMB Member'}</p>
                    {data.company_name && (
                      <p className="text-[12px] font-semibold text-slate-300 mt-1">{data.company_name}</p>
                    )}
                    <div className="w-[120px] h-[2px] bg-[#FDBC12] my-3"></div>
                    <p className="text-[12px] text-[#94A2B8] line-clamp-2 min-h-[36px]">
                      {data.about_company || 'Active Rotarian member in RMB Jaipur fellowship chapter.'}
                    </p>
                  </div>

                  <div className="flex items-center justify-between border-t border-slate-800 pt-3 mt-3">
                    <div className="flex items-center gap-2">
                      <img className="w-5 h-5 cursor-pointer opacity-80 hover:opacity-100" src={facebook} alt="FB" />
                      <img className="w-5 h-5 cursor-pointer opacity-80 hover:opacity-100" src={insta} alt="Insta" />
                      <img className="w-5 h-5 cursor-pointer opacity-80 hover:opacity-100" src={linkdin} alt="LinkedIn" />
                    </div>

                    <button
                      className="bg-[#FDBC12] hover:bg-amber-400 px-4 py-1.5 rounded-lg text-[#101729] text-xs font-black transition shadow"
                      onClick={() => {
                        window.location.href = '/members';
                      }}
                    >
                      Connect With Me
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Teams;
